module.exports = __webpack_public_path__ + "assets/category-105d8dc6ff776edf251b4bb857077a00.svg";